export const FETCH_USER_LETTERS_TO_PRINT_REQUEST = 'FETCH_USER_LETTERS_TO_PRINT_REQUEST';
export const FETCH_USER_LETTERS_TO_PRINT_SUCCESS = 'FETCH_USER_LETTERS_TO_PRINT_SUCCESS';
export const FETCH_USER_LETTERS_TO_PRINT_FAILURE = 'FETCH_USER_LETTERS_TO_PRINT_FAILURE';

